module.exports = __webpack_public_path__ + "img/a4563e6.png";